import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { types as sdkTypes } from '../../util/sdkLoader';
import { REVIEW_TYPE_OF_PROVIDER, REVIEW_TYPE_OF_CUSTOMER } from '../../util/types';
import { ensureCurrentUser, ensureUser } from '../../util/data';
import { withViewport } from '../../util/contextHelpers';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import {
  Page,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  Footer,
  AvatarLarge,
  NamedLink,
  ListingCard,
  Reviews,
  ButtonTabNavHorizontal,
} from '../../components';
import { TopbarContainer, NotFoundPage } from '../../containers';
import { loadData } from './ProfilePage.duck';
import config from '../../config';

import css from './ProfilePage.css';

const { UUID } = sdkTypes;
const MAX_MOBILE_SCREEN_WIDTH = 768;

export class ProfilePageComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // keep track of which reviews tab to show in desktop viewport
      showReviewsType: REVIEW_TYPE_OF_PROVIDER,
    };

    this.showOfProviderReviews = this.showOfProviderReviews.bind(this);
    this.showOfCustomerReviews = this.showOfCustomerReviews.bind(this);
  }

  showOfProviderReviews() {
    this.setState({
      showReviewsType: REVIEW_TYPE_OF_PROVIDER,
    });
  }

  showOfCustomerReviews() {
    this.setState({
      showReviewsType: REVIEW_TYPE_OF_CUSTOMER,
    });
  }

  render() {
    const {
      scrollingDisabled,
      currentUser,
      provider,
      userShowError,
      queryListingsError,
      listings,
      reviews,
      queryReviewsError,
      viewport,
      intl,
    } = this.props;

    const ensuredCurrentUser = ensureCurrentUser(currentUser);
    const profileProvider = ensureUser(provider);
    const isCurrentUser =
      ensuredCurrentUser.id && profileProvider.id && ensuredCurrentUser.id.uuid === profileProvider.id.uuid;
    const displayName = profileProvider.attributes.secondaryName || profileProvider.attributes.name;
    const bio = profileProvider.attributes.description;
    const hasBio = !!bio;
    const hasListings = listings.length > 0;
    const isMobileLayout = viewport.width < MAX_MOBILE_SCREEN_WIDTH;
    const legalInfo  = profileProvider.attributes.legalInfo;
    const rentTerms = profileProvider.attributes.rentTerms;
    const countryId = profileProvider.attributes?.countryId; 

    const editLinkMobile = isCurrentUser ? (
      <NamedLink className={css.editLinkMobile} name="ProfileSettingsPage">
        <FormattedMessage id="ProfilePage.editProfileLinkMobile" />
      </NamedLink>
    ) : null;
    const editLinkDesktop = isCurrentUser ? (
      <NamedLink className={css.editLinkDesktop} name="ProfileSettingsPage">
        <FormattedMessage id="ProfilePage.editProfileLinkDesktop" />
      </NamedLink>
    ) : null;

    const asideContent = (
      <div className={css.asideContent}>
        <AvatarLarge className={css.avatar} user={provider} disableProfileLink />
        <h1 className={css.mobileHeading}>
          {displayName}
        </h1>
        {editLinkMobile}
        {editLinkDesktop}
      </div>
    );

    const listingsContainerClasses = classNames(css.listingsContainer, {
      [css.withBioMissingAbove]: !hasBio,
    });

    const reviewsError = (
      <p className={css.error}>
        <FormattedMessage id="ProfilePage.loadingReviewsFailed" />
      </p>
    );
    // const reviewsOfProvider = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_PROVIDER);
    const reviewsOfProvider = reviews;
    const reviewsOfCustomer = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_CUSTOMER);

    const mobileReviews = (
      <div className={css.mobileReviews}>
        <h2 className={css.mobileReviewsTitle}>
          <FormattedMessage
            id="ProfilePage.reviewsOfProviderTitle"
            values={{ count: reviewsOfProvider.length }}
          />
        </h2>
        {queryReviewsError ? reviewsError : null}
        <Reviews reviews={reviewsOfProvider} />
        {/* <h2 className={css.mobileReviewsTitle}>
          <FormattedMessage
            id="ProfilePage.reviewsOfCustomerTitle"
            values={{ count: reviewsOfCustomer.length }}
          />
        </h2>
        {queryReviewsError ? reviewsError : null}
        <Reviews reviews={reviewsOfCustomer} /> */}
      </div>
    );

    const desktopReviewTabs = [
      {
        text: (
          <h3 className={css.desktopReviewsTitle}>
            <FormattedMessage
              id="ProfilePage.reviewsOfProviderTitle"
              values={{ count: reviewsOfProvider.length }}
            />
          </h3>
        ),
        selected: this.state.showReviewsType === REVIEW_TYPE_OF_PROVIDER,
        onClick: this.showOfProviderReviews,
      },
      // {
      //   text: (
      //     <h3 className={css.desktopReviewsTitle}>
      //       <FormattedMessage
      //         id="ProfilePage.reviewsOfCustomerTitle"
      //         values={{ count: reviewsOfCustomer.length }}
      //       />
      //     </h3>
      //   ),
      //   selected: this.state.showReviewsType === REVIEW_TYPE_OF_CUSTOMER,
      //   onClick: this.showOfCustomerReviews,
      // },
    ];

    const desktopReviews = (
      <div className={css.desktopReviews}>
        <ButtonTabNavHorizontal className={css.desktopReviewsTabNav} tabs={desktopReviewTabs} />

        {queryReviewsError ? reviewsError : null}

        {this.state.showReviewsType === REVIEW_TYPE_OF_PROVIDER ? (
          <Reviews reviews={reviewsOfProvider} />
        ) : (
          <Reviews reviews={reviewsOfCustomer} />
        )}
      </div>
    );

    const legalInfoContent = legalInfo ? (
      <section className={css.wrapper}>
        <div className={css.container}>
          <p className={css.heading}>
            <FormattedMessage id="ProfilePage.heading" />
          </p>
          <p className={css.textContainer}>
            <span className={css.boldText}>
              <FormattedMessage id="ProfilePage.sellerHeading" />{' '}
            </span>
            <span className={css.text}>{legalInfo?.businessName}</span>
          </p>
          {legalInfo?.regon && (
            <p className={css.textContainer}>
              <span className={css.boldText}>
                <FormattedMessage id="ProfilePage.registrationNumber" />
              </span>
              {':  '}
              <span className={css.text}>{legalInfo.regon}</span>
            </p>
          )}
          {legalInfo?.nip && (
            <p className={css.textContainer}>
              <span className={css.boldText}>
              <FormattedMessage id="ProfilePage.taxIdentificationNumber" />
              </span>
              {':  '}
              <span className={css.text}>{legalInfo.nip}</span>
            </p>
          )}
          {legalInfo?.address && countryId && (
            <div className={css.textContainer}>
              <p className={css.boldText}>
                <FormattedMessage id="ProfilePage.registerAddress" />
              </p>
              <p className={css.textAddress}>{legalInfo.address?.address}</p>
              <p className={css.textAddress}>{legalInfo.address?.city}</p>
              <p className={css.textAddress}>
                <FormattedMessage
                  id={`StripeConnectAccountForm.countryNames.${countryId.toUpperCase()}`}
                />
              </p>
            </div>
          )}
        </div>
        {rentTerms && (
          <div className={css.container}>
            <p className={css.heading}>
              <FormattedMessage id="ProfilePage.termsHeading" />
            </p>
            <div className={css.textContainer}>
              <a href={rentTerms} className={css.termsLink} target="_blank">
                <FormattedMessage id="ProfilePage.download" />
              </a>
            </div>
          </div>
        )}
      </section>
    ) : null;

    const providerAddress = profileProvider.attributes.location?.address ? (
      <div className={css.section}>
        <p className={css.title}>
          <FormattedMessage id={'ProfilePage.serviceDeliveryAddress'} />
        </p>
        <p  className={css.text}>{profileProvider.attributes.location?.address}</p>
      </div>
    ) : null;

    const openingHours = profileProvider.attributes?.openingHours ? (
      <div className={css.section}>
        <p  className={css.title}>
          <FormattedMessage id={'ProfilePage.openingHours'} />
        </p>
        <p className={classNames(css.openingHours, css.text)}>{profileProvider.attributes.openingHours}</p>
      </div>
    ) : null;

    const mainContent = (
      <div>
        <h1 className={css.desktopHeading}>
          <FormattedMessage id="ProfilePage.desktopHeading" values={{ name: displayName }} />
        </h1>
        <div className={css.descriptionContainer}>
          {hasBio ? <p className={css.bio}>{bio}</p> : null}
          {providerAddress}
          {openingHours}
        </div>
        {legalInfoContent}
        {hasListings ? (
          <div className={listingsContainerClasses}>
            <h2 className={css.listingsTitle}>
              <FormattedMessage
                id="ProfilePage.listingsTitle"
                values={{ count: listings.length }}
              />
            </h2>
            <ul className={css.listings}>
              {listings.map(l => (
                <li className={css.listing} key={l.id.uuid}>
                  <ListingCard listing={l} />
                </li>
              ))}
            </ul>
          </div>
        ) : null}
        {isMobileLayout ? mobileReviews : desktopReviews}
      </div>
    );

    let content;

    if (userShowError && userShowError.status === 404) {
      return <NotFoundPage />;
    } else if (userShowError || queryListingsError) {
      content = (
        <p className={css.error}>
          <FormattedMessage id="ProfilePage.loadingDataFailed" />
        </p>
      );
    } else {
      content = mainContent;
    }

    const schemaTitle = intl.formatMessage(
      {
        id: 'ProfilePage.schemaTitle',
      },
      {
        name: displayName,
        siteTitle: config.siteTitle,
      }
    );

    return (
      <Page
        scrollingDisabled={scrollingDisabled}
        title={schemaTitle}
        schema={{
          '@context': 'http://schema.org',
          '@type': 'ProfilePage',
          name: schemaTitle,
          mainEntity: {
            '@type': 'LocalBusiness'
          }
        }}
      >
        <LayoutSideNavigation>
          <LayoutWrapperTopbar>
            <TopbarContainer currentPage="ProfilePage" />
          </LayoutWrapperTopbar>
          <LayoutWrapperSideNav className={css.aside}>{asideContent}</LayoutWrapperSideNav>
          <LayoutWrapperMain>{content}</LayoutWrapperMain>
          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSideNavigation>
      </Page>
    );
  }
}

ProfilePageComponent.defaultProps = {
  currentUser: null,
  user: null,
  userShowError: null,
  queryListingsError: null,
  reviews: [],
  queryReviewsError: null,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const {
    userId,
    userShowError,
    queryListingsError,
    userListingRefs,
    reviews,
    queryReviewsError,
  } = state.ProfilePage;
  const userMatches = getMarketplaceEntities(state, [{ type: 'provider', id: userId }]);
  const provider = userMatches.length === 1 ? userMatches[0] : null;
  const listings = getMarketplaceEntities(state, userListingRefs);
  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
    provider,
    userShowError,
    queryListingsError,
    listings,
    reviews,
    queryReviewsError,
  };
};

const ProfilePage = compose(
  connect(mapStateToProps),
  withViewport,
  injectIntl
)(ProfilePageComponent);

ProfilePage.loadData = params => {
  const id = new UUID(params.id);
  return loadData(id);
};

export default ProfilePage;
